import React from 'react';
import { useLocation } from 'react-router';

export default function useIsSessionLivePage() {
  const location = useLocation();
  return React.useMemo(() => location.pathname === '/live-session' || location.pathname === '/live-session/', [location.pathname]);
}
